import React from 'react'

import InputGroup from 'components/shared/InputGroup'
import { SortBy as SortByModel } from 'types/offers'
import { useStoreActions, useStoreState } from 'store'
import { scrollToTableTop } from 'utils/scroll'

const optionsDesktop = [
  { value: 'rate', label: 'Rate' },
  { value: 'apr', label: 'APR' },
  { value: 'fees', label: 'Fees' },
  { value: 'payment', label: 'Mo. payment' },
]

const optionsMobile = [
  { value: 'rate', label: 'Rate' },
  { value: 'apr', label: 'APR' },
  { value: 'fees', label: 'Fees' },
  { value: 'payment', label: 'Payment' },
]

const SortBy = (props: any) => {
  const { sortBy } = useStoreState(actions => actions.offers)
  const { setSortBy } = useStoreActions(actions => actions.offers)
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)

  const handleChange = (value: SortByModel) => {
    setSortBy(value)
    onInputTracking({ name: 'sort', label: 'sort by', type: 'SORT', value })
    if (!isDesktop) {
      scrollToTableTop()
    }
  }

  return (
    <>
      <div className="form-element-container mb-2">
        <div className="FormLabel mb-1">Sort by</div>
        {!isDesktop ? (
          <InputGroup
            {...props}
            id="sortBy"
            value={sortBy}
            options={optionsMobile}
            className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill mb-4"
            onClick={handleChange}
          />
        ) : (
          <InputGroup
            {...props}
            id="sortBy"
            value={sortBy}
            options={optionsDesktop}
            className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill mb-4"
            onClick={handleChange}
          />
        )}
      </div>
    </>
  )
}

export default SortBy
